import { Heart, Mail, Phone, MapPin } from "lucide-react";
const Footer = () => {
  return <footer className="bg-card border-t border-border py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo et description */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              
              <div>
                <h3 className="text-xl font-serif font-semibold text-primary">YUMELI</h3>
                <p className="text-sm text-muted-foreground"></p>
              </div>
            </div>
            <p className="text-muted-foreground mb-4 max-w-md">
              Yumeli aide les familles à entretenir un lien affectif avec leurs grands-parents 
              en leur offrant chaque mois une surprise bienveillante, créative ou mémorielle.
            </p>
            <div className="flex flex-col gap-2 text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                
                
              </div>
              
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4" />
                <span>Paris, France</span>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            
            <ul className="space-y-2 text-sm text-muted-foreground">
              
              
              
              
            </ul>
          </div>

          {/* Informations légales */}
          <div>
            
            <ul className="space-y-2 text-sm text-muted-foreground">
              
              
              
              
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center text-sm text-muted-foreground">
          <p>&copy; 2024 Yumeli. Tous droits réservés. Fait avec ❤️ pour nos aînés.</p>
        </div>
      </div>
    </footer>;
};
export default Footer;